import React from 'react'
import { StrategyType } from './common'

interface Props {
  strategy: StrategyType
  className: string
}

interface State { }

export class StrategyBadge extends React.Component<Props, State> {
  static defaultProps() {
    return {
      className: ''
    }
  }
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  get label() {
    return this.props.strategy === 'desktop' ? 'デスクトップ' : 'モバイル'
  }

  public render() {
    return (
      <span className={`${this.props.className} badge badge-secondary`}>{this.label}</span>
    )
  }
}